import { If } from "components";

import { ConfirmApproveModal } from "../../ConfirmApproveModal";
import { RejectModal } from "../../RejectModal";
import { ReturnModalModalsProps } from "../ReturnModal.types";

export const ReturnModalModals = ({
  returnItemId,
  refetchReturnDetails,
  refetchReturns,
  approveModal,
  rejectModal
}: ReturnModalModalsProps) => {
  return (
    <>
      <If condition={approveModal.value}>
        <ConfirmApproveModal
          onClose={approveModal.setFalse}
          isOpen={approveModal.value}
          returnId={returnItemId}
          refetchDetails={refetchReturnDetails}
          refetchReturns={refetchReturns}
        />
      </If>

      <If condition={rejectModal.value}>
        <RejectModal
          onClose={rejectModal.setFalse}
          isOpen={rejectModal.value}
          returnId={returnItemId}
          refetchDetails={refetchReturnDetails}
          refetchReturns={refetchReturns}
        />
      </If>
    </>
  );
};
